<template>
  <div class="career-table-container mt-2">
    <NewGenericBTable
      :display_id="'CareerTable'"
      :key="tableKey"
      :search_filter="true"
      :columns_display="true"
      :fields="fields"
      :url="'/mesh/alt-career/'"
      :pre_filter="preFilter"
      :show_pagination="true"
      :pagination="20"
      @actual_items="onActualItems"
      @total_items="onTotalItems"
    >
      <template #head(selected)>
        <div
          class="d-flex justify-content-center"
          v-if="showSelectionCheckbox"
        >
          <b-checkbox
            :checked="allPageSelected"
            @change="toggleSelectAllPage"
          ></b-checkbox>
        </div>
      </template>
      <template #cell(selected)="row">
        <div
          class="d-flex"
          v-if="
            showSelectionCheckbox &&
            row.item.egress_profiles &&
            row.item.egress_profiles.length > 0
          "
        >
          <b-checkbox
            class="ml-auto mr-auto"
            :checked="
              row.item.egress_profiles.every((id) =>
                selected_egress_profiles.includes(id)
              ) && selected_egress_profiles.length > 0
            "
            @change="$emit('change-selected-career', row.item.egress_profiles)"
          ></b-checkbox>
        </div>
      </template>
      <template v-slot:cell(faculty)="row">
        <div class="tdClass">
          {{ getFacultyName(row.item.faculty) }}
        </div>
      </template>
      <template v-slot:cell(egress_profile_year)="row">
        <div class="tdClass">
          {{ getEgressProfileYears(row.item).join(", ") }}
        </div>
      </template>
      <template v-slot:cell(name)="row">
        <div class="tdClass">
          {{ row.item.name }}
        </div>
      </template>
      <template v-slot:cell(egress_profile_curricular_number)="row">
        <div class="tdClass">
          {{ getEgressProfileCodes(row.item).join(", ") }}
        </div>
      </template>
      <template v-slot:cell(egress_profile_modality)="row">
        <div class="tdClass">
          {{ getEgressProfileModalities(row.item).join(", ") }}
        </div>
      </template>
      <template v-slot:cell(type)="row">
        <div class="tdClass">
          {{ getCareerType(row.item.egress_profile_type) }}
        </div>
      </template>
      <template v-slot:head(actions)>
        <b-button
          class="p-auto"
          variant="none"
          v-b-tooltip.v-secondary.top.noninteractive="
            $t('careerOrPrograms.careerListView.showHideAll', {
              action: select_all
                ? $t('reusable.common.hideAll')
                : $t('reusable.common.showAll'),
              entity: $getVisibleNames(
                'mesh.egressprofile',
                true,
                'Perfiles de Egreso'
              ),
            })
          "
          @click="toggleAllDetails"
        >
          <b-icon-chevron-up v-if="select_all"></b-icon-chevron-up>
          <b-icon-chevron-down v-else></b-icon-chevron-down>
        </b-button>
      </template>
      <template v-slot:cell(actions)="row">
        <div
          class="noprint"
          :class="{
            'container-generic-buttons':
              row.item.egress_profiles.length != 0,
          }"
        >
          <template v-if="row.item.egress_profiles.length == 0">
            <ButtonSmall
              v-can="'mesh.add_career'"
              v-if="
                allows_crud &&
                ([
                  'DIRECTIVOS ACADÉMICOS INSTITUCIONALES',
                  'DIRECTIVOS ACADÉMICOS (CAMPUS)',
                ].some((group) => user.group_names.includes(group)) ||
                  user.is_superuser ||
                  $hasObjectPermission('mesh.faculty', 'add') ||
                  $hasObjectPermission('mesh.egressprofile', 'add'))
              "
              :tooltip_text="
                $t('reusable.common.createTooltip', {
                  entity: $getVisibleNames(
                    'mesh.egressprofile',
                    false,
                    'Perfil de Egreso'
                  ),
                })
              "
              :click_button="() => $emit('create-egress-profile', row.item)"
              :icon="'plus'"
              :variant="'none'"
            >
            </ButtonSmall>
          </template>
          <template v-else>
            <div>
              <b-button
                v-if="getEgressProfilesList(row.item).length > 1"
                size="sm"
                @click="openDetails(row.item)"
                v-b-tooltip.v-secondary.top.noninteractive="
                  $getVisibleNames(
                    'mesh.egressprofile',
                    true,
                    'Perfiles de Egreso'
                  )
                "
                variant="light"
                class="border-button-class"
              >
                <b-badge variant="none" class="badge-wrapper">
                  <span style="font-size: 14px">
                    {{ getEgressProfileCodes(row.item).length }}
                  </span>
                </b-badge>
              </b-button>
              <template
                v-else-if="getEgressProfilesList(row.item).length == 1"
              >
                <ButtonWrapperSmall
                  :id_button="`${row.item.id}`"
                  :tooltip_text="
                    $t('careerOrPrograms.careerListView.goToAction')
                  "
                  :class="``"
                >
                  <template #popover-content-wrapper>
                    <b-button
                      variant="primary"
                      v-for="egress_profile_id in filterEgressProfile(
                        row.item.egress_profiles
                      )"
                      @click="redirectToEgressProfile(egress_profile_id)"
                      class="dropdown-class"
                      :key="'perfil' + egress_profile_id"
                    >
                      {{
                        $getVisibleNames(
                          "mesh.egressprofile",
                          false,
                          "Perfil de Egreso"
                        )
                      }}
                    </b-button>
                    <b-button
                      variant="primary"
                      v-for="egress_profile_id in filterEgressProfile(
                        row.item.egress_profiles
                      )"
                      @click="redirectToMatrix1(egress_profile_id)"
                      class="dropdown-class"
                      :key="'Matriz 1' + egress_profile_id"
                    >
                      {{
                        $getVisibleNames(
                          "manual.matriz_1",
                          false,
                          "Matriz 1"
                        )
                      }}
                    </b-button>
                    <b-button
                      variant="primary"
                      v-for="egress_profile_id in filterEgressProfile(
                        row.item.egress_profiles
                      )"
                      :key="'Matriz 2' + egress_profile_id"
                      @click="redirectToMatrix2(egress_profile_id)"
                      class="dropdown-class"
                    >
                      {{
                        $getVisibleNames(
                          "manual.matriz_2",
                          false,
                          "Matriz 2"
                        )
                      }}
                    </b-button>
                    <b-button
                      variant="primary"
                      v-for="egress_profile_id in filterEgressProfile(
                        row.item.egress_profiles
                      )"
                      :key="'Matriz 3' + egress_profile_id"
                      @click="redirectToMatrix3(egress_profile_id)"
                      class="dropdown-class"
                    >
                      {{
                        $getVisibleNames(
                          "manual.matriz_3",
                          false,
                          "Matriz 3"
                        )
                      }}
                    </b-button>
                    <template
                      v-if="
                        institution &&
                        institution.internal_use_id == 'duoc.cl'
                      "
                    >
                      <b-button
                        variant="primary"
                        v-for="egress_profile_id in filterEgressProfile(
                          row.item.egress_profiles
                        )"
                        :key="'Matriz 4' + egress_profile_id"
                        @click="redirectToMatrix4(egress_profile_id)"
                        class="dropdown-class"
                      >
                        {{
                          $getVisibleNames(
                            "manual.matriz_4",
                            false,
                            "Matriz 4"
                          )
                        }}
                      </b-button>
                    </template>
                    <b-button
                      variant="primary"
                      v-for="egress_profile_id in filterEgressProfile(
                        row.item.egress_profiles
                      )"
                      :key="'Plan de Estudio' + egress_profile_id"
                      @click="redirectToStudyPlan(egress_profile_id)"
                      class="dropdown-class"
                    >
                      {{ $t("careerOrPrograms.careerListView.studyPlan") }}
                    </b-button>
                    <b-button
                      variant="primary"
                      v-for="egress_profile_id in filterEgressProfile(
                        row.item.egress_profiles,
                        true
                      )"
                      :key="'Malla Curricular' + egress_profile_id"
                      @click="redirectToCurricularMesh(egress_profile_id)"
                      class="dropdown-class"
                    >
                      {{
                        $t("careerOrPrograms.careerListView.curricularMesh")
                      }}
                    </b-button>
                  </template>
                </ButtonWrapperSmall>
              </template>
            </div>
          </template>
          <ButtonSmall
            v-if="
              allows_crud &&
              ([
                'DIRECTIVOS ACADÉMICOS INSTITUCIONALES',
                'DIRECTIVOS ACADÉMICOS (CAMPUS)',
              ].some((group) => user.group_names.includes(group)) ||
                user.is_superuser ||
                $hasObjectPermission(
                  'mesh.faculty',
                  'change',
                  row.item.faculty
                ))
            "
            :tooltip_text="
              $t('reusable.common.editTooltip', {
                entity: $getVisibleNames('mesh.career', false, 'Programa'),
              })
            "
            v-can="'mesh.change_career'"
            :click_button="
              () => $bvModal.show(`edit-career-modal-${row.item.id}`)
            "
            :class="`mx-1`"
            :icon="'square'"
          ></ButtonSmall>
          <ButtonSmall
            v-else-if="allows_crud"
            v-can="'mesh.change_career'"
            class="mx-1"
            :tooltip_text="``"
            :disabled_button="true"
            :icon="'square'"
          ></ButtonSmall>
          <ButtonSmall
            v-if="
              allows_crud &&
              ([
                'DIRECTIVOS ACADÉMICOS INSTITUCIONALES',
                'DIRECTIVOS ACADÉMICOS (CAMPUS)',
              ].some((group) => user.group_names.includes(group)) ||
                user.is_superuser)
            "
            v-can="'mesh.delete_career'"
            :click_button="() => $emit('ask-delete', row.item.id)"
            :tooltip_text="
              $t('reusable.common.deleteTooltip', {
                entity: $getVisibleNames('mesh.career', false, 'Programa'),
              })
            "
            :icon="'trash'"
          ></ButtonSmall>
          <ButtonSmall
            v-else-if="allows_crud"
            v-can="'mesh.delete_career'"
            :tooltip_text="``"
            :disabled_button="true"
            :icon="'trash'"
          ></ButtonSmall>
        </div>
        <b-modal
          :id="`edit-career-modal-${row.item.id}`"
          :title="
            $t('reusable.common.editModalTitle', {
              entity: $getVisibleNames('mesh.career', false, 'Programa'),
            })
          "
          size="lg"
          hide-footer
        >
          <CareerForm
            :Career="row.item"
            @updated="slotUpdatedCareer"
            :show_title="false"
          ></CareerForm>
        </b-modal>
      </template>
      <template #row-details="row">
        <b-card
          v-if="getEgressProfilesList(row.item).length > 1"
          class="p-0"
        >
          <div>
            <GenericBTable
              :items="getEgressProfilesList(row.item)"
              :fields="fieldsEgressProfile"
              :per_page="getEgressProfilesList(row.item).length"
              :show_pagination="false"
              :search_filter="false"
              :default_striped="false"
              :default_bordered="false"
              :default_borderless="true"
              :default_hover="true"
              :hidden_table_header="false"
              :show_skeleton_efect="false"
              :columns_display="false"
            >
              <template #cell(selected)="data">
                <div
                  class="d-flex"
                  v-if="
                    institution &&
                    (institution.internal_use_id == 'duoc.cl' ||
                      institution.internal_use_id == 'iacc.cl') &&
                    ([
                      'DIRECTIVOS ACADÉMICOS INSTITUCIONALES',
                      'DIRECTIVOS ACADÉMICOS (CAMPUS)',
                    ].some((group) => user.group_names.includes(group)) ||
                      user.is_superuser ||
                      $hasObjectPermission(
                        'mesh.faculty',
                        'change',
                        row.item.faculty
                      ))
                  "
                >
                  <b-checkbox
                    class="ml-auto mr-auto"
                    :checked="
                      selected_egress_profiles.includes(data.item.id)
                    "
                    @change="
                      $emit('change-selected-egress-profile', data.item.id)
                    "
                  ></b-checkbox>
                </div>
              </template>
              <template v-slot:cell(actions)="data">
                <ButtonWrapperSmall
                  :id_button="`${data.item.id}`"
                  :tooltip_text="
                    $t('careerOrPrograms.careerListView.goToAction')
                  "
                  :class="``"
                >
                  <template #popover-content-wrapper>
                    <b-button
                      variant="primary"
                      v-for="egress_profile_id in filterEgressProfile([
                        data.item.id,
                      ])"
                      v-b-tooltip.v-secondary.top.noninteractive="
                        $t('careerOrPrograms.careerListView.goToProfile')
                      "
                      @click="redirectToEgressProfile(egress_profile_id)"
                      class="dropdown-class"
                      :key="'perfil' + egress_profile_id"
                    >
                      {{
                        $getVisibleNames(
                          "mesh.egressprofile",
                          false,
                          "Perfil de Egreso"
                        )
                      }}
                    </b-button>
                    <b-button
                      variant="primary"
                      v-for="egress_profile_id in filterEgressProfile([
                        data.item.id,
                      ])"
                      v-b-tooltip.v-secondary.top.noninteractive="
                        $t('careerOrPrograms.careerListView.goToThe', {
                          entity: $getVisibleNames(
                            'manual.matriz_1',
                            false,
                            'Matriz 1'
                          ),
                        })
                      "
                      @click="redirectToMatrix1(egress_profile_id)"
                      class="dropdown-class"
                      :key="'Matriz 1' + egress_profile_id"
                    >
                      {{
                        $getVisibleNames(
                          "manual.matriz_1",
                          false,
                          "Matriz 1"
                        )
                      }}
                    </b-button>
                    <b-button
                      variant="primary"
                      v-for="egress_profile_id in filterEgressProfile([
                        data.item.id,
                      ])"
                      v-b-tooltip.v-secondary.top.noninteractive="
                        $t('careerOrPrograms.careerListView.goToThe', {
                          entity: $getVisibleNames(
                            'manual.matriz_2',
                            false,
                            'Matriz 2'
                          ),
                        })
                      "
                      :key="'Matriz 2' + egress_profile_id"
                      @click="redirectToMatrix2(egress_profile_id)"
                      class="dropdown-class"
                    >
                      {{
                        $getVisibleNames(
                          "manual.matriz_2",
                          false,
                          "Matriz 2"
                        )
                      }}
                    </b-button>
                    <b-button
                      variant="primary"
                      v-for="egress_profile_id in filterEgressProfile([
                        data.item.id,
                      ])"
                      :key="'Matriz 3' + egress_profile_id"
                      v-b-tooltip.v-secondary.top.noninteractive="
                        $t('careerOrPrograms.careerListView.goToThe', {
                          entity: $getVisibleNames(
                            'manual.matriz_3',
                            false,
                            'Matriz 3'
                          ),
                        })
                      "
                      @click="redirectToMatrix3(egress_profile_id)"
                      class="dropdown-class"
                    >
                      {{
                        $getVisibleNames(
                          "manual.matriz_3",
                          false,
                          "Matriz 3"
                        )
                      }}
                    </b-button>
                    <template
                      v-if="
                        institution &&
                        institution.internal_use_id == 'duoc.cl' &&
                        filterEgressProfile([data.item.id]).length > 0
                      "
                    >
                      <b-button
                        variant="primary"
                        v-for="egress_profile_id in filterEgressProfile([
                          data.item.id,
                        ])"
                        :key="'Matriz 4' + egress_profile_id"
                        v-b-tooltip.v-secondary.top.noninteractive="
                          $t('careerOrPrograms.careerListView.goToThe', {
                            entity: $getVisibleNames(
                              'manual.matriz_4',
                              false,
                              'Matriz 4'
                            ),
                          })
                        "
                        @click="redirectToMatrix4(egress_profile_id)"
                        class="dropdown-class"
                      >
                        {{
                          $getVisibleNames(
                            "manual.matriz_4",
                            false,
                            "Matriz 4"
                          )
                        }}
                      </b-button>
                    </template>
                    <b-button
                      variant="primary"
                      v-for="egress_profile_id in filterEgressProfile([
                        data.item.id,
                      ])"
                      :key="'Plan de Estudio' + egress_profile_id"
                      v-b-tooltip.v-secondary.top.noninteractive="
                        $t(
                          'careerOrPrograms.careerListView.goToStudyPlan'
                        )
                      "
                      @click="redirectToStudyPlan(egress_profile_id)"
                      class="dropdown-class"
                    >
                      {{
                        $t("careerOrPrograms.careerListView.studyPlan")
                      }}
                    </b-button>
                    <b-button
                      variant="primary"
                      v-for="egress_profile_id in filterEgressProfile(
                        [data.item.id],
                        true
                      )"
                      :key="'Malla Curricular' + egress_profile_id"
                      v-b-tooltip.v-secondary.top.noninteractive="
                        $t(
                          'careerOrPrograms.careerListView.goToCurricularMesh'
                        )
                      "
                      @click="redirectToCurricularMesh(egress_profile_id)"
                      class="dropdown-class"
                    >
                      {{
                        $t(
                          "careerOrPrograms.careerListView.curricularMesh"
                        )
                      }}
                    </b-button>
                  </template>
                </ButtonWrapperSmall>
              </template>
            </GenericBTable>
          </div>
        </b-card>
      </template>
      <template #empty>
        <div class="text-center p-3">
          {{ $t("reusable.common.noMatchingData") }}
        </div>
      </template>
      <template #emptyfiltered>
        <div class="text-center p-3">
          {{ $t("reusable.common.noMatchingData") }}
        </div>
      </template>
    </NewGenericBTable>
  </div>
</template>

<script>
import * as names from "@/store/names";
import { mapGetters } from "vuex";
export default {
  name: "CareerTable",
  components: {
    NewGenericBTable: () => import("@/components/reusable/NewGenericBTable"),
    GenericBTable: () => import("@/components/reusable/GenericBTable"),
    CareerForm: () => import("./Career/CareerForm"),
    ButtonSmall: () =>
      import("@/components/reusable/Buttons/Small/ButtonSmall"),
    ButtonWrapperSmall: () =>
      import("@/components/reusable/Buttons/Small/ButtonWrapperSmall"),
  },
  props: {
    allows_crud: {
      type: Boolean,
      default: false,
    },
    profile_type_id: {
      type: Number,
      default: null,
    },
    selected_egress_profiles: {
      type: Array,
      default() {
        return [];
      },
    },
    fully_visible_professor_egress_profiles: {
      type: Array,
      default() {
        return [];
      },
    },
    fields: {
      type: Array,
      required: true,
    },
    fieldsEgressProfile: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      select_all: false,
      current_page_items: [],
      items_with_details: {},
      total_items: 0,
    };
  },
  computed: {
    ...mapGetters({
      user: "getUser",
      institution: "getInstitution",
      egressProfiles: names.EGRESS_PROFILES,
      egressProfileTypes: names.PROFILE_TYPES,
      faculties: names.FACULTIES,
      modalities_egress_profiles: names.MODALITIES_EGRESS_PROFILE,
    }),
    showSelectionCheckbox() {
      return (
        this.institution &&
        (this.institution.internal_use_id == "duoc.cl" ||
          this.institution.internal_use_id == "iacc.cl") &&
        ([
          "DIRECTIVOS ACADÉMICOS INSTITUCIONALES",
          "DIRECTIVOS ACADÉMICOS (CAMPUS)",
          "DIRECTIVOS FACULTAD O ESCUELA",
          "DIRECTORES DE CARRERA",
          "DIRECTORES DE CARRERA (CAMPUS)",
          "ADMINISTRATIVOS INSTRUCCIONALES",
        ].some((group) => this.user.group_names.includes(group)) ||
          this.user.is_superuser)
      );
    },
    preFilter() {
      let params = [];
      if (this.profile_type_id)
        params.push(`egress_profile_type=${this.profile_type_id}`);
      return params.join("&");
    },
    tableKey() {
      return `career-table-${this.preFilter}`;
    },
    allPageSelected() {
      if (this.current_page_items.length === 0) return false;
      const pageEgressProfileIds = [];
      this.current_page_items.forEach((career) => {
        if (
          career.egress_profiles &&
          career.egress_profiles.length > 0
        ) {
          pageEgressProfileIds.push(...career.egress_profiles);
        }
      });
      if (pageEgressProfileIds.length === 0) return false;
      return pageEgressProfileIds.every((id) =>
        this.selected_egress_profiles.includes(id)
      );
    },
  },
  methods: {
    onActualItems(items) {
      this.current_page_items = items;
    },
    onTotalItems(count) {
      this.total_items = count;
      this.$emit('total-items', count);
    },
    toggleSelectAllPage() {
      const pageEgressProfileIds = [];
      this.current_page_items.forEach((career) => {
        if (
          career.egress_profiles &&
          career.egress_profiles.length > 0
        ) {
          pageEgressProfileIds.push(...career.egress_profiles);
        }
      });
      this.$emit("toggle-select-all-page", pageEgressProfileIds);
    },
    getFacultyName(faculty_id) {
      const instance = this.faculties.find((x) => x.id == faculty_id);
      if (instance) return instance.name;
      return "...";
    },
    getCareerType(type_id) {
      let profile_type = this.egressProfileTypes.find(
        (x) => x.id == type_id
      );
      return profile_type ? profile_type.name : "";
    },
    getModalityName(modality_id) {
      const modality = this.modalities_egress_profiles.find(
        (x) => x.id == modality_id
      );
      return modality ? modality.name : "";
    },
    getEgressProfilesList(career) {
      return this.egressProfiles
        .filter((e) => e.career == career.id)
        .map((e) => ({
          ...e,
          career_name: career.name,
          faculty_name: this.getFacultyName(career.faculty),
          egress_profile_type_name: this.getCareerType(
            career.egress_profile_type
          ),
        }))
        .sort((a, b) => new Date(b.init_date) - new Date(a.init_date));
    },
    getEgressProfileYears(career) {
      const profiles = this.getEgressProfilesList(career);
      return [
        ...new Set(
          profiles.map((e) => {
            if (e.init_date != null)
              return parseInt(String(e.init_date).substr(0, 4));
          })
        ),
      ];
    },
    getEgressProfileCodes(career) {
      const profiles = this.getEgressProfilesList(career);
      return profiles.map((e) => e.code);
    },
    getEgressProfileModalities(career) {
      const profiles = this.getEgressProfilesList(career);
      return [
        ...new Set(profiles.map((e) => this.getModalityName(e.modality))),
      ];
    },
    filterEgressProfile(egress_profiles_ids, all_egress_profiles = false) {
      if (all_egress_profiles) return egress_profiles_ids;
      if (this.user && this.user.group_names.includes("PROFESORES")) {
        return egress_profiles_ids.filter((x) =>
          this.fully_visible_professor_egress_profiles.includes(x)
        );
      } else if (
        this.user &&
        this.user.group_names.includes("ESTUDIANTES")
      ) {
        if (
          this.user &&
          this.user.student_card &&
          this.user.student_card.egress_profile != null
        ) {
          return egress_profiles_ids.filter(
            (x) => x == this.user.student_card.egress_profile
          );
        } else return [];
      }
      return egress_profiles_ids;
    },
    toggleAllDetails() {
      this.select_all = !this.select_all;
      this.current_page_items.forEach((item) => {
        this.$set(
          this.items_with_details,
          item.id,
          this.select_all
        );
        item._showDetails = this.select_all;
      });
    },
    openDetails(item) {
      const current = item._showDetails || false;
      this.$set(item, "_showDetails", !current);
      this.$set(this.items_with_details, item.id, !current);
      if (this.select_all && current) this.select_all = false;
      else if (
        !this.select_all &&
        this.current_page_items.every(
          (x) => x._showDetails
        )
      )
        this.select_all = true;
    },
    slotUpdatedCareer(career) {
      this.$bvModal.hide(`edit-career-modal-${career.id}`);
      this.$emit("career-updated");
    },
    redirectToEgressProfile(egress_profile_id) {
      this.$router.push({
        name: "EgressProfileView",
        params: { egress_profile_id: egress_profile_id },
      });
    },
    redirectToMatrix1(egress_profile_id) {
      this.$router.push({
        name: "Matrix1View",
        params: { egress_profile_id: egress_profile_id },
      });
    },
    redirectToMatrix2(egress_profile_id) {
      this.$router.push({
        name: "Matrix2View",
        params: { egress_profile_id: egress_profile_id },
      });
    },
    redirectToMatrix3(egress_profile_id) {
      this.$router.push({
        name: "Matrix3View",
        params: { egress_profile_id: egress_profile_id },
      });
    },
    redirectToMatrix4(egress_profile_id) {
      this.$router.push({
        name: "Matrix4View",
        params: { egress_profile_id: egress_profile_id },
      });
    },
    redirectToStudyPlan(egress_profile_id) {
      this.$router.push({
        name: "StudyPlanView",
        params: { egress_profile_id: egress_profile_id },
      });
    },
    redirectToCurricularMesh(egress_profile_id) {
      this.$router.push({
        name: "CurricularMeshView",
        params: { egress_profile_id: egress_profile_id },
      });
    },
  },
};
</script>

<style scoped>
.career-table-container {
  padding: 0;
}
.badge-wrapper {
  width: 17.5px !important;
  height: 17.5px !important;
}
.container-generic-buttons {
  display: flex;
  justify-self: right;
}
.border-button-class {
  width: 23px !important;
  height: 23px !important;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  background-color: #ffffff;
  color: #333;
  border: 1px solid #bdbdbd;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);
  padding: 0;
  transition: background-color 0.3s, color 0.3s, box-shadow 0.3s;
}
.border-button-class:hover,
.border-button-class:focus {
  background-color: #f7f9fa;
  color: #0056b3;
  box-shadow: 0 2px 2px rgba(0, 0, 0, 0.1);
}
.dropdown-class {
  width: 100%;
  height: 35px !important;
  margin-bottom: 4px;
  border-radius: 4px;
  padding: 0;
  transition: background-color 0.3s, color 0.3s, box-shadow 0.3s;
}
.dropdown-class:hover {
  cursor: pointer;
}
.tdClass {
  text-align: left !important;
}
.card >>> .card-body {
  padding: 0 !important;
}
.card-body >>> .b-table-container {
  margin-top: 0;
  margin-bottom: 0;
  margin-left: 1;
  margin-right: 1;
}
</style>
